module.exports = __webpack_public_path__ + "2d73d7458983f50f5e230db7832539b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/city.jpg
// module id = 171
// module chunks = 0